import * as requestActions from './requestAction';
import * as authActions from './authAction';
import * as dashboardActions from './dashboardAction';
import * as filterActions from "./filterActions";
import * as mapCarsActions from "./mapCarsAction";
import * as mapRoutesActions from "./mapRoutesAction";
import * as mapActions from "./mapAction";
import * as rentActions from "./rentAction";
import * as carsActions from "./carsAction";
import * as groupActions from "./groupActions";
import * as reportActions from "./reportAction";
import * as userActions from "./userAction";
import * as driverActions from "./driverAction";
import * as settingsActions from "./settingsAction";

const ActionCreator = Object.assign(
    {},
    requestActions,
    authActions,
    dashboardActions,
    filterActions,
    mapCarsActions,
    mapRoutesActions,
    mapActions,
    rentActions,
    carsActions,
    groupActions,
    reportActions,
    userActions,
    driverActions,
    settingsActions
    );

export default ActionCreator;